import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import {
    Grid,
} from '@mui/material';
import { Button, Input } from 'Components';
import { Alert } from '@mui/material';
// Components
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { NotificationManager } from 'Components/Notifications';

import {
    openQuickResponseCreateEdit,
    createQuickResponse,
    updateQuickResponse,
    searchQuickResponse,
    clearRedux
} from 'Redux/actions';

const QuickMesssageEdit = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const [QuickMData, setQuickMData] = useState({});
    const [error, setError] = useState('');
    //Selectors
    const {
        openCreateEditQuickResponse,
        response,
        QuickResponse,
        loadingCreateEdit
    } = useSelector(state => state.quickResponseRedux);


    useEffect(() => {
        if (response?.error === false) {
            let messageNotification = (QuickResponse?.name)?messages['FSM_SETTINGS_QUICK_RESPONSE_update_success']:messages['FSM_SETTINGS_QUICK_RESPONSE_create_success'];
            NotificationManager.success(
				messageNotification,
				messages['success'],
				3000,
				null,
				null,
				'Success',
			);
            handleClose();
        }
    }, [response]);

    const handleClose = useCallback(() => {
        setQuickMData({});
        setError('');
        dispatch(clearRedux("FSM_SETTINGS_QUICK_RESPONSE", {
            openCreateEditQuickResponse: false,
            loadingCreateEdit: false,
            response: {},
            QuickResponse: {}
        }));

        dispatch(searchQuickResponse())
        dispatch(openQuickResponseCreateEdit(false))
    });

    useEffect(() => {
        if (QuickResponse?.name) {
            setQuickMData({
                name: QuickResponse?.name
            });
        }
    }, [QuickResponse]);

    const onSubmit = useCallback(() => {

        if (!QuickMData?.name) {
            setError(messages['fsm_settings_form_nameRequired']);
            return false;
        }

        if (QuickResponse?.name) {
            dispatch(updateQuickResponse({
                id: QuickResponse?.id,
                name: QuickMData?.name
            }))
        } else {
            dispatch(createQuickResponse({
                name: QuickMData?.name
            }))
        }

    });



    let title = (QuickResponse?.name) ? messages['FSM_SETTINGS_QUICK_RESPONSE_edit'] : messages['FSM_SETTINGS_QUICK_RESPONSE_title'];
    return (
        <Modal
            title={title}
            open={openCreateEditQuickResponse}
            loading={loadingCreateEdit}
            size={`small`}
            handleClose={() => handleClose()}
            position="right"
        >
            <ModalBody style={{ overflow: 'hidden', padding: 10 }}>
                <div >
                    {
                        error &&
                        <Alert severity="error">{error}</Alert>
                    }
                    <Grid
                        container
                        justifyContent={'center'}
                        direction={'column'}
                        className="paddingBody"
                        spacing={2}
                    >
                        <Grid item xs={12} >
                            <Input
                                id="name"
                                type="text"
                                label={messages['fsm_settings_form_name']}
                                placeholder={messages['fsm_settings_form_name']}
                                value={QuickMData.name || ""}
                                onChange={(value) => setQuickMData({ ...QuickMData, name: value })}
                                required
                                requiredMessage={messages['required_field']}
                                maxLength={30}
                            />
                        </Grid>


                    </Grid>
                </div>
            </ModalBody>
            <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }}>
                <Button
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    className="btn-blue"
                    onClick={onSubmit}
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default QuickMesssageEdit;